"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _hooks = require("../../Products/hooks");
const Root = exports.Root = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  textAlign: 'center',
  height: _hooks.TITLE_MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    height: _hooks.TITLE_DESKTOP_HEIGHT
  }
}));